/**
 * Waben-Reaktionen (amendment 24): an emoji thrown at a cell, rising from it on the map of
 * everybody who has that part of the city on screen in the minute after.
 *
 * A reaction is anonymous by construction: what is kept is the cell, the emoji and the time —
 * nobody's name, not even the thrower's own, so there is nothing to show, export or leak. It is
 * shown for a minute and kept for an hour, for the counts in the cell's sheet.
 */

export const REACTIONS = ['🔥', '😍', '🍻', '🥳', '👀', '💃'] as const;

export type Reaction = (typeof REACTIONS)[number];

export function isReaction(value: unknown): value is Reaction {
  return REACTIONS.some((reaction) => reaction === value);
}

/** How long a reaction rises on the maps of those who look: a minute after it was thrown. */
export const REACTION_SHOW_MS = 60_000;

/** How long it counts in its cell's sheet, and how long the row is kept at all. */
export const REACTION_KEEP_MS = 60 * 60 * 1000;

/** The most regions one read may name: the one in the middle of the map and its ring. */
export const REACTION_REGIONS_MAX = 7;
